import styled from "styled-components";

export const Wrapper = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  transition: var(--transition);
  div.card-container {
    width: 80%;
    height: 70%;
    @media screen and (max-width: 900px) {
      width: 90%;
      height: 90%;
      overflow-y: visible;
    }
  }
`;

export const Card = styled.div`
  width: 100%;
  height: 100%;
  background-color: #f5f5f7;
  border-radius: 20px;
  display: grid;
  grid-template-columns: 1fr 2fr;
  overflow: hidden;

  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const DetailsContainer = styled.div`
  background-color: var(--white);
  padding: 1rem;
  @media screen and (max-width: 900px) {
    padding: 0;
  }
`;
export const DismisContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  padding: 1rem;
  .view-icon {
    color: #e0296c;
    margin: 0 1rem;
    display: none;
    &:hover {
      cursor: pointer;
      color: var(--red-dark);
    }
    @media screen and (max-width: 900px) {
      display: block;
    }
  }

  .dismis-icon {
    color: #e0296c;
    transition: var(--transition);

    &:hover {
      cursor: pointer;
      color: var(--red-dark);
    }
  }
`;
export const ImgContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 900px) {
    display: none;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;
  margin: 0 1rem;

  h4,
  h5 {
    margin: 0;
    color: var(--textColor);
  }
  h4 {
    font-weight: bold;
  }
  p {
    color: var(--text-secondary-color);
    margin: 0px;
  }
`;
export const Position = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  .view-icon {
    color: #e0296c;
    &:hover {
      cursor: pointer;
      color: var(--red-dark);
    }
  }
  @media screen and (max-width: 900px) {
    flex-direction: column;
    align-items: start;
    justify-content: start;
    p {
      display: none;
    }
    .view-icon {
      display: none;
    }
  }
`;

export const Info = styled.div`
  margin: 1rem;
  p {
    color: var(--textColor);
  }
  h5 {
    color: #e0296c;
    margin: 0;
  }
`;
